import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { SportsList } from './SportsList/SportsList';
import { SportsForm } from './SportsForm/SportsForm';
import { CustomizedSportsState } from 'src/AppState/CmsState/SportsState/SportsState';
import { useAppStateContext } from 'src/AppState/AppState';
import { ColumnOneOfTwo, MainContent, TwoColumnResponsiveContentReverse } from 'src/domains/layouts/shared/layout/Layout.style';
import { withConfig } from 'src/utils/withConfig';

export const Sports = withConfig(theme => observer('Sports', () => {
    const { sdkStaff, trpcClient } = useAppStateContext();
    const [sportState] = useState(() => new CustomizedSportsState(sdkStaff.models, sdkStaff, theme, trpcClient));

    return (
        <MainContent>
            <TwoColumnResponsiveContentReverse>
                <ColumnOneOfTwo>
                    <SportsList sportState={sportState}/>
                </ColumnOneOfTwo>

                <ColumnOneOfTwo>
                    <SportsForm sportState={sportState}/>
                </ColumnOneOfTwo>
            </TwoColumnResponsiveContentReverse>
        </MainContent>
    );
}));
